import { render } from "./PrensaSection.vue?vue&type=template&id=3a3ffa33&ts=true"
import script from "./PrensaSection.vue?vue&type=script&lang=ts"
export * from "./PrensaSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__